import { Dialog, DialogContent, DialogProps } from "@mui/material";
import { Box } from "@mui/system";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";

import PoolCreateUpdate, { PoolCreateUpdateProps } from "./PoolCreateUpdate";

export interface OwnProps {
  createUpdateProps: PoolCreateUpdateProps;
}

type Props = OwnProps & DialogProps;

export default function PoolCreateUpdateModal({ createUpdateProps, ...dialogProps }: Props) {
  const isCreate = !createUpdateProps.poolId;

  return (
    <Dialog fullWidth maxWidth='md' {...dialogProps}>
      <AppModalTitle
        onClose={() => dialogProps?.onClose && dialogProps?.onClose({}, "escapeKeyDown")}
      >
        {isCreate ? "Create new" : "Edit"} pool
      </AppModalTitle>
      <DialogContent>
        <Box sx={{ py: 1 }}>
          <PoolCreateUpdate {...createUpdateProps} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
